import React, { useCallback } from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";
import { styles } from "./style";
import { useSelector } from "react-redux";
import { useAppThunkDispatch } from "redux/store";
import { createLeadTag, deleteLeadTag } from "redux/slice/lead-tags";
import { getBookmarkTagForLead } from "redux/selector";
import { LeadTagType } from "type/lead-tag";

interface Props extends WithStyles<typeof styles> {
	leadId: number;
	showLabel?: boolean;
}

const Component: React.FC<Props> = ({ leadId, showLabel, classes = {} }) => {
	const bookmarkTag = useSelector((state: any) => getBookmarkTagForLead(state, leadId));
	const dispatch = useAppThunkDispatch();

	const toggleBookmark = useCallback(() => {
		if (bookmarkTag) {
			dispatch(deleteLeadTag({leadTag: bookmarkTag}));
		} else {
			dispatch(createLeadTag({ leadTag: {
				leadId: leadId,
				text: LeadTagType.BOOKMARKED.id,
			}}));
		}
	}, [bookmarkTag, leadId, dispatch]);

	return (
		<>
			<Mui.Button onClick={toggleBookmark} className={classes.container}>
				<FeatherIcon>
					<Icons.Bookmark className={bookmarkTag ? classes.activeBookmark : classes.bookmark} />
				</FeatherIcon>
				{showLabel && <span className={classes.label}>Bookmark</span>}
			</Mui.Button>
		</>
	);
};

export const Bookmark = withStyles(Component, styles);